/**
 * Content of the "À propos" page (/a-propos). Reviews are quoted word for word from Trustpilot
 * (verified reviews), shortened to one passage when they are long.
 */

export const FOUNDERS = [
  {
    name: 'Nacim Belkouaci',
    role: 'Fondateur',
    image: '/static/about/nacim.jpg',
  },
  {
    name: 'Emre Solak',
    role: 'Cofondateur',
    image: '/static/about/emre.jpg',
  },
];

export const HERO = {
  kicker: 'À propos de Formabel',
  title: 'Une jeune équipe belge qui met les formateurs',
  titleAccent: 'en lumière.',
  lead:
    'Formabel est une plateforme 100 % belge : les formateurs indépendants publient leurs formations et sont payés en ligne, et chacun réserve une formation près de chez lui en quelques clics.',
};

export const STATS = [
  { value: '100+', label: 'membres inscrits' },
  { value: '30+', label: 'formations en ligne' },
  { value: '4,4/5', label: 'note moyenne sur Trustpilot' },
  { value: '100 %', label: 'belge et indépendant' },
];

export const MISSION = {
  label: 'Notre mission',
  text: "Remettre l'expertise des professionnels indépendants",
  accent: "au centre de l'attention.",
};

export const STORY = [
  {
    title: 'Le constat',
    text: 'En Belgique, beaucoup de formateurs indépendants talentueux manquent de visibilité.',
  },
  {
    title: 'Le déclic',
    text:
      "Après des années dans la formation et le numérique, Nacim voit qu'il manque un outil simple, humain et efficace.",
  },
  {
    title: 'Formabel',
    text:
      "Toute l'offre de formation réunie au même endroit, dans le respect de la liberté de chaque formateur.",
  },
];

export const AUDIENCES = [
  {
    label: 'Formateurs',
    title: 'Partagez votre savoir-faire, on gère le reste',
    text:
      "Réservations, paiements, visibilité : vous vous concentrez sur l'essentiel, la formation.",
    tags: ['Coiffure', 'Esthétique', 'Automobile', 'Barbier', 'Bâtiment'],
    highlighted: true,
  },
  {
    label: 'Apprenants',
    title: 'Une formation claire, près de chez vous',
    text:
      'Comparez, réservez et payez en ligne, sans appeler dix personnes ni visiter quinze sites.',
  },
];

export const TRUSTPILOT_SCORE = '4,4/5';

export const REVIEWS = [
  {
    text:
      'Très belle plateforme de formation. Tout est clair, bien organisé et facile à utiliser. Les contenus sont intéressants et bien expliqués, ce qui permet d’apprendre dans de bonnes conditions. L’équipe est professionnelle et disponible en cas de besoin.',
    author: 'Julien',
    role: 'Apprenant',
  },
  {
    text:
      'Je propose mes formations via leur plateforme et tout se déroule parfaitement bien. L’organisation est claire, le suivi est sérieux et l’équipe est professionnelle. C’est un vrai plaisir de collaborer avec eux.',
    author: 'La Clinic Brussels',
    role: 'Formatrice',
  },
  {
    text:
      "J'ai réservé une formation sur Formabel et tout s'est très bien passé. Simple, rapide et efficace, dès le debut j'ai reçu toutes les info nécessaires. Je recommande vivement!",
    author: 'Noah',
    role: 'Apprenant',
  },
  {
    text:
      'La formation était très instructive et très enrichissante ; j’ai beaucoup appris. J’ai particulièrement apprécié la répartition entre la théorie le matin et la pratique l’après-midi.',
    author: 'Carlo Spina',
    role: 'Apprenant',
  },
  {
    text:
      'Superbe plateforme pour mettre en évidence mes formations en esthétique automobile. Merci Nacim et son équipe.',
    author: "Nathan d'Ultimate Care",
    role: 'Formateur en esthétique automobile',
  },
  {
    text:
      'La plateforme est intuitive, la recherche de formations est rapide et la réservation se fait facilement. J’ai apprécié la clarté du processus et la simplicité d’utilisation.',
    author: 'Cliente',
    role: 'Apprenante',
  },
];

export const COMMITMENTS = [
  {
    title: 'Paiement sécurisé',
    text: 'Le paiement passe par Stripe, une référence mondiale du paiement en ligne.',
  },
  {
    title: 'Des avis vérifiés',
    text: 'Seuls les élèves qui ont réservé peuvent laisser un avis sur une formation.',
  },
  {
    title: 'Une vraie équipe',
    text: "Une question ? Une personne de l'équipe vous répond, pas un robot.",
  },
];

export const VALUES = [
  {
    title: "La pratique d'abord",
    text: "Des formations en présentiel, où l'on apprend le geste avec un vrai pro.",
  },
  {
    title: 'La simplicité',
    text: 'Trouver, réserver et payer une formation en quelques clics.',
  },
  {
    title: "L'indépendance",
    text: 'Une plateforme privée, au service de la liberté de chaque formateur.',
  },
];

export const FINAL_CTA = {
  title: 'Prêt à vous lancer ?',
  text: 'Que vous vouliez apprendre ou enseigner, Formabel vous accompagne.',
};
